export const DEFAULT_ICON_SIZE = 16;
export const LARGE_ICON_SIZE = 20;
